import DateTimeUtils from '@/common/datetime-utils'

const extractPublishingDate = (publishDate) => {
  if (!publishDate) {
    return null
  }
  return DateTimeUtils.formatDateWithText(publishDate)

}

const extractImage = (fields) => {
  if (!fields.primaryImage) {
    return null
  }
  return {
    url: fields.primaryImage.fields.file.url,
    alt: fields.primaryImage.fields.title
  }

}

const extractTagList = (tagList) => {
  if (!tagList) {
    return null
  }
  return tagList.map(tag => {
    return {
      name: tag.fields.name,
      identifier: tag.fields.identifier,
      category: tag.fields.category
    }
  })
}

const extractOtherArticles = (otherArticles) => {
  if (!otherArticles || otherArticles.length === 0 ) {
    return undefined
  }
  return otherArticles.map(article => {
    return {
      href: article.fields.slug,
      heading: article.fields.heading,
      paragraph: article.fields.preamble,
      image: extractImage(article.fields),
      tags: extractTagList(article.fields.tagList),
      additionalText: extractPublishingDate(article.fields.publishDate)
    }

  })
}

export const extractArticle = (response) => {
  const fields = response.fields

  return {
    publishDate: extractPublishingDate(fields.publishDate),
    tags: extractTagList(fields.tagList),
    heading: fields.heading,
    preamble: fields.preamble,
    image: extractImage(fields),
    content: fields.content,
    relatedArticles: extractOtherArticles(fields.relatedArticles),
    moreArticles: extractOtherArticles(fields.moreArticles)
  }
}
